// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    AArrowDown,
    AArrowUp,
    ALargeSmall,
    Accessibility,
    Activity,
    Ad,
    AirVent,
    Airplay,
    AlarmClock,
    AlarmClockCheck,
    AlarmClockMinus,
    AlarmClockOff,
    AlarmClockPlus,
    AlarmSmoke,
    Album,
    AlignCenterHorizontal,
    AlignCenterVertical,
    AlignEndHorizontal,
    AlignEndVertical,
    AlignHorizontalDistributeCenter,
    AlignHorizontalDistributeEnd,
    AlignHorizontalDistributeStart,
    AlignHorizontalJustifyCenter,
    AlignHorizontalJustifyEnd,
    AlignHorizontalJustifyStart,
    AlignHorizontalSpaceAround,
    AlignHorizontalSpaceBetween,
    AlignStartHorizontal,
    AlignStartVertical,
    AlignVerticalDistributeCenter,
    AlignVerticalDistributeEnd,
    AlignVerticalDistributeStart,
    AlignVerticalJustifyCenter,
    AlignVerticalJustifyEnd,
    AlignVerticalJustifyStart,
    AlignVerticalSpaceAround,
    AlignVerticalSpaceBetween,
    Ambulance,
    Ampersand,
    Ampersands,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "a-arrow-down" through "ampersands", inclusive. */
const shard: Record<string, LucideIcon> = {
    "a-arrow-down": AArrowDown,
    "a-arrow-up": AArrowUp,
    "a-large-small": ALargeSmall,
    accessibility: Accessibility,
    activity: Activity,
    ad: Ad,
    "air-vent": AirVent,
    airplay: Airplay,
    "alarm-clock": AlarmClock,
    "alarm-clock-check": AlarmClockCheck,
    "alarm-clock-minus": AlarmClockMinus,
    "alarm-clock-off": AlarmClockOff,
    "alarm-clock-plus": AlarmClockPlus,
    "alarm-smoke": AlarmSmoke,
    album: Album,
    "align-center-horizontal": AlignCenterHorizontal,
    "align-center-vertical": AlignCenterVertical,
    "align-end-horizontal": AlignEndHorizontal,
    "align-end-vertical": AlignEndVertical,
    "align-horizontal-distribute-center": AlignHorizontalDistributeCenter,
    "align-horizontal-distribute-end": AlignHorizontalDistributeEnd,
    "align-horizontal-distribute-start": AlignHorizontalDistributeStart,
    "align-horizontal-justify-center": AlignHorizontalJustifyCenter,
    "align-horizontal-justify-end": AlignHorizontalJustifyEnd,
    "align-horizontal-justify-start": AlignHorizontalJustifyStart,
    "align-horizontal-space-around": AlignHorizontalSpaceAround,
    "align-horizontal-space-between": AlignHorizontalSpaceBetween,
    "align-start-horizontal": AlignStartHorizontal,
    "align-start-vertical": AlignStartVertical,
    "align-vertical-distribute-center": AlignVerticalDistributeCenter,
    "align-vertical-distribute-end": AlignVerticalDistributeEnd,
    "align-vertical-distribute-start": AlignVerticalDistributeStart,
    "align-vertical-justify-center": AlignVerticalJustifyCenter,
    "align-vertical-justify-end": AlignVerticalJustifyEnd,
    "align-vertical-justify-start": AlignVerticalJustifyStart,
    "align-vertical-space-around": AlignVerticalSpaceAround,
    "align-vertical-space-between": AlignVerticalSpaceBetween,
    ambulance: Ambulance,
    ampersand: Ampersand,
    ampersands: Ampersands,
};

export default shard;
